<template>
  <div class="notification-container" :class="{ 'show': show, [type]: true }">
    <div class="notification">
      <svg v-if="type === 'success'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20 6L9 17l-5-5"></path>
      </svg>
      <svg v-else-if="type === 'error'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      <svg v-else-if="type === 'copy'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
      <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, onMounted, onUnmounted, watch } from 'vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  message: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'success',
    validator: (value) => ['success', 'error', 'info', 'copy'].includes(value)
  },
  duration: {
    type: Number,
    default: 5000
  }
});

const emit = defineEmits(['update:show']);

let timeout;

// Fonction pour démarrer le timer
const startTimer = () => {
  // Nettoyer le timer existant
  if (timeout) {
    clearTimeout(timeout);
  }
  
  // Démarrer un nouveau timer si show est true et duration > 0
  if (props.show && props.duration > 0) {
    timeout = setTimeout(() => {
      emit('update:show', false);
    }, props.duration);
  }
};

// Surveiller les changements de la propriété show
watch(() => props.show, (newValue) => {
  if (newValue) {
    startTimer();
  }
});

onMounted(() => {
  if (props.show && props.duration > 0) {
    startTimer();
  }
});

onUnmounted(() => {
  if (timeout) {
    clearTimeout(timeout);
  }
});
</script>

<style scoped>
.notification-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  transform: translateY(100px);
  opacity: 0;
  transition: all 0.3s ease;
}

.notification-container.show {
  transform: translateY(0);
  opacity: 1;
}

.notification {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-radius: 14px;
  box-shadow: 0 18px 40px -16px rgba(20, 48, 40, 0.45);
  background: white;
  min-width: 300px;
  max-width: 400px;
  margin-bottom: 16px;
  animation: slideIn 0.3s ease forwards;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Couleurs Peelo : succès = vert Peelo, info/copy = vert Peelo, erreur = rouge propre */
.success .notification {
  background: #143028;
  color: #DAFFD1;
}

.error .notification {
  background: #E5484D;
  color: white;
}

.info .notification {
  background: #143028;
  color: white;
}

.copy .notification {
  background: #143028;
  color: white;
}

.notification svg {
  flex-shrink: 0;
}

.notification span {
  font-size: 14px;
  font-weight: 500;
}
</style> 